import {
  ClientAdvertisingBannerControllerGetActiveBannersApiArg,
  ClientAdvertisingBannerControllerGetActiveBannersApiResponse,
} from '@/app/store/api/restApi';
import { emptyApi } from '@/app/store/api/emptyApi';

export const bannersApi = emptyApi.injectEndpoints({
  endpoints: (build) => ({
    getBanners: build.query<
      ClientAdvertisingBannerControllerGetActiveBannersApiResponse,
      ClientAdvertisingBannerControllerGetActiveBannersApiArg
    >({
      query: () => 'advertising/banners',
    }),
  }),
});

export const { useGetBannersQuery } = bannersApi;
